import React from 'react';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';
import InfobipAccess from './InfobipAccess';

function InfobipAccessPage() {
  return (
    <>
      <Can I="edit" a="WhatsappCampaign">
        {() => <InfobipAccess />}
      </Can>
      <Can not I="edit" a="WhatsappCampaign">
        {() => <NotPermissionPage />}
      </Can>
    </>
  );
}

export default InfobipAccessPage;
